export function filterMapper(filters: any) {
   const { quick_search, filter_elements, direct_search } = filters;
   const data = {
      direct_search: direct_search
         ? { ...direct_search, keyLabel: direct_search?.key_label, valueLabel: direct_search?.value_label }
         : null,
      quick_search:
         quick_search?.map((qs: any) => ({ ...qs, keyLabel: qs?.key_label, valueLabel: qs?.value_label, important: !!qs.important })) || [],
      filter_elements:
         filter_elements?.map((fe: any) => ({
            ...fe,
            keyLabel: fe?.key_label,
            valueLabel: fe?.value_label,
            important: !!fe.important,
         })) || [],
   };

   if (!data.direct_search) delete data.direct_search;

   return data;
}
